
  import { AccountModule, AccountStore } from '@/store/account';
  import { Options, Vue } from 'vue-class-component';
  import { NavigationModule, NavigationStore } from '@/store/navigation';
  import RegisterSmall from '@/components/RegisterSmall.vue';

  @Options({
    components: {
      RegisterSmall
    }
  })
  export default class RegisterSmallComponent extends Vue {
    private accountStore: AccountModule = AccountStore;
    private navigationStore: NavigationModule = NavigationStore;

    mounted() {
      this.accountStore.initAuthDataFromLocalStorage();
    }
  }
